import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueHighlightJS from 'vue-highlightjs';
import SortedTablePlugin from "vue-sorted-table";
import 'highlight.js/styles/default.css';
import python from 'highlight.js/lib/languages/python';
import json from 'highlight.js/lib/languages/json';
import App from './app.vue';
import store from './store';
import router from './router';
import components from './components';
import filters from './filters';
import '@/assets/styles/main.scss';


Vue.config.productionTip = false;
components.register();
filters.register();
Vue.use(VueHighlightJS, {languages: {python, json}});
Vue.use(VModal);
Vue.use(SortedTablePlugin);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
